import React, { useContext } from 'react';
import { AptunoButton, Icon, SIZES, VARIANTS } from '@aptuno/aptuno-ui';
import { ActionsBarRoot } from '../EstateApplication.styled';
import { estateApplicationStageContext } from '../..';
import { Blue, HeaderButton, TitleSection } from '../EstateApplication.styled';
import { ApplicationTenantDisclaimerWrapper } from './ApplicationTenantDisclaimer.styled';
import { TextBox } from '../EstateApplication.styled';
import { useRouter } from 'next/router';
import { ApplicantType, ApplicationStateSteps } from '@contexts/Estate';
import { useTrackingSource } from '@contexts/Shared/utils';
import { useAnalyticsTracker } from '@services/analytics';
import { ApplicationConditionsReviewed } from '@contexts/Estate/EstateApplication/domain/events/application-conditions-reviewed.event';

const ApplicationTenantDisclaimer = () => {
  const router = useRouter();
  const eventTracker = useAnalyticsTracker();

  const estateApplication = useContext(estateApplicationStageContext);

  const originSource = useTrackingSource();

  const handleOnBackClick = () => {
    estateApplication && estateApplication.setCurrentState(ApplicationStateSteps.documentsCheck);
  };

  const handleNextStepClick = () => {
    segmentTrack();
    estateApplication && estateApplication.setCurrentState(ApplicationStateSteps.basicInformation);
  };
  const segmentTrack = () => {
    const estateLegalId = router && router.query.estateLegalId;

    eventTracker.trackEvent(new ApplicationConditionsReviewed(originSource, ApplicantType.TENANT, `${estateLegalId}`));
  };

  return (
    <ApplicationTenantDisclaimerWrapper>
      <HeaderButton appearance={VARIANTS.SECONDARY} isCircular onClick={handleOnBackClick}>
        <Icon icon="arrowleftalt" />
      </HeaderButton>
      <TitleSection>
        Aplicarás como
        <Blue>tomador</Blue>
      </TitleSection>
      <TextBox>
        <h2>¿Qué es un tomador?</h2>
        <p>
          Como tomador, tu nombre estará en el contrato y aplicaremos nuestro estudio de riesgo y crédito sobre tu vida
          crediticia y otras bases de datos para determinar si puedes arrendar un inmueble con Aptuno.{' '}
          <strong>Serás el principal responsable del pago del canon de arrendamiento.</strong>
        </p>
      </TextBox>
      <ActionsBarRoot>
        <AptunoButton appearance={VARIANTS.PRIMARY} size={SIZES.BIGGEST} onClick={handleNextStepClick}>
          Comenzar aplicación
          <Icon width={'12px'} height={'12px'} icon="Arrow_Right" />
        </AptunoButton>
      </ActionsBarRoot>
    </ApplicationTenantDisclaimerWrapper>
  );
};

export { ApplicationTenantDisclaimer };
